import { Button } from "@/common/components/button";
import Table from "@/common/components/Table";
import { H3 } from "@/common/elements/headings";
import {
  batchTableHeadersPreview,
  batchTableKeysPreview,
  getBatchTableDataPreview,
} from "./data";
import { KeyValueObj } from "@/common/types";

interface IPreviewProps {
  batchData?: any;
  deliveryData?: any;
  productBatches: any;
  formData?: KeyValueObj;
  onBack: () => void;
  setFormData?: React.Dispatch<React.SetStateAction<KeyValueObj>>;
}

export default function Preview({
  productBatches,
  formData,
  setFormData,
  onBack,
}: IPreviewProps) {
  const tableData = Object.values(productBatches).flat();

  const pickupOptionView = formData?.pickup_option.split("_").join(" ");
  const pickupOptionLogic = formData?.pickup_option;
  const pickupAddress = formData?.pickup_address?.address_line_one;

  return (
    <>
      <div className="w-full h-[20rem] ">
        <section>
          <H3>Batch Selection</H3>
          <Table
            tableHeaders={batchTableHeadersPreview}
            tableKeys={batchTableKeysPreview}
            removeFilters
            tableData={getBatchTableDataPreview(tableData) || []}
            full
            rowLineColor="light"
          />
        </section>

        <section className="my-5">
          <H3>Delivery Infomation</H3>

          <div className="p-4 space-y-2">
            {Array.isArray(formData?.logistics_company) &&
              formData?.logistics_company?.map((company: any) => (
                <div
                  key={company?.id}
                  className="p-4 border rounded-xl shadow-sm bg-white"
                >
                  <h2 className="text-lg font-semibold">
                    {company?.name || "--"}
                  </h2>
                  <p className="text-gray-600">
                    {company?.street_address}, {company?.city},{" "}
                    {company?.state || "--"}
                  </p>
                  <span className="text-gray-600">
                    {company?.phone_number || "--"}
                  </span>
                </div>
              ))}
          </div>

          <div className="px-5 pt-5 border rounded-xl shadow-sm bg-white p-5">
            <H3>Product details</H3>

            <div className="p-4 grid grid-cols-2 gap-4 ">
              <div>
                <strong> Category: </strong>
                <span>{formData?.category || "--"}</span>
              </div>

              <div>
                <strong> Packaging type: </strong>
                <span>{formData?.package_type || "--"}</span>
              </div>

              {formData?.category === "Cold Storage" && (
                <>
                  <div>
                    <strong> Min Tempertature: </strong>
                    <span>{formData?.min_temperature || "--"}</span> {" 'c"}
                  </div>

                  <div>
                    <strong> Max Tempertature: </strong>
                    <span>{formData?.max_temperature || "--"}</span>
                    {" 'c"}
                  </div>
                </>
              )}
            </div>

            <div className="grid grid-cols-3 w-full px-5">
              <div>
                <strong> Lenght: </strong>
                <span>{formData?.length || "--"}</span>
                {" cm"}
              </div>

              <div>
                <strong> Height: </strong>
                <span>{formData?.height || "--"}</span>
                {" cm "}
              </div>

              <div>
                <strong> Width: </strong>
                <span>{formData?.width || "--"}</span>
                {" cm"}
              </div>
            </div>
          </div>

          <div className="px-5 pt-5 border rounded-xl shadow-sm bg-white">
            <H3>Other details</H3>

            <div className="p-4 grid grid-cols-2 gap-4 ">
              <div>
                <strong> Preferred Vehicle Type: </strong>
                <br />
                <span>{formData?.vehicle_needed || "--"}</span>
              </div>

              <div>
                <strong> Pickup Option: </strong>
                <br />
                <span>{pickupOptionView || "--"}</span>
              </div>

              {pickupOptionLogic === "logistics_pickup" && (
                <div>
                  <strong> Pickup Address: </strong>
                  <br />
                  <span>{pickupAddress || "--"}</span>{" "}
                </div>
              )}

              <div>
                <strong> Expected Delivery Date: </strong>
                <br />
                <span>{formData?.expected_delivery_date || "--"}</span>
              </div>

              <div>
                <strong> Sender's Secondary Phone Number: </strong>
                <br />
                <span>{formData?.sender_phone_number || "--"}</span>
              </div>
              <div>
                <strong> Recipent's Secondary Phone Number: </strong>
                <br />
                <span>{formData?.recipent_phone_number || "--"}</span>
              </div>
            </div>
          </div>
        </section>

        <div className="flex-row  gap-5 mt-10  p-5 pb-20">
          <Button secondary onClick={onBack}>
            Back
          </Button>
          <Button onClick={setFormData}>Submit</Button>
        </div>
      </div>
    </>
  );
}
